/**
 * 一行极小的「构建于 YYYY-MM-DD HH:mm」版本标记 —— **唯一的渲染实现**。
 *
 * 刻意**不加按钮、不加图标、不做得醒目**：它只服务于"确认当前跑的是哪个构建"。
 * 文案与兜底逻辑都在 `lib/buildStamp.ts`（纯函数，有单测）；这里只管样式，
 * 于是"长什么样"和"显示什么"各只有一处。
 *
 * ⚠️ 改样式时别破坏窄屏约定：`truncate` + 容器 `min-w-0` 是既有约定，
 *    不要给它加 `flex-1`（`flex-basis: 0` 会把文字挤没）。
 *
 * 显示位置（各处都由外壳决定，本组件不关心自己挂在哪）：
 *  · `AppShell`（家长 / 学生端）：PC 侧边栏页脚 + 手机头部（`md:hidden`）两处；
 *  · `AdminShell`（系统管理后台）：深色顶栏里、账号那一行的下面；
 *  · 管理端两个独立全屏页（登录 / 绑定动态口令）：卡片下方的页脚位置。
 * 颜色 `text-slate-400` 是刻意选的中性灰：在家长端的白底和后台的深色底上都够看，
 * 于是**不需要**每个调用点各传一套颜色（`cn()` 不做 tailwind 合并，两份
 * `text-*` 同时在就等于把结果交给 CSS 顺序，别再走那条路）。
 */
import { cn } from '../../lib/utils';
import { formatBuildStamp, readBuildTime } from '../../lib/buildStamp';

export function BuildStamp({ className }: { className?: string }) {
  return (
    <p className={cn('truncate text-[11px] leading-4 text-slate-400', className)}>
      {formatBuildStamp(readBuildTime())}
    </p>
  );
}
